module.exports = __webpack_public_path__ + "img/8.927e0ffd.jpg";